__turbopack_context__.v({
  "fieldset": "EZ5PWa_fieldset",
  "legend": "EZ5PWa_legend",
});
